export const SITUACAO_KEY_INTERVENCAO_HUMANA = 'INTERVENCAO_HUMANA';
export const SITUACAO_KEY_ACORDO_MANUAL = 'ACORDO_MANUAL';
export const SITUACAO_KEY_ACORDO_IA = 'ACORDO_IA';
export const SITUACAO_KEY_SEM_RESPOSTA = 'SEM_RESPOSTA';
